"use client";

import { Button, HStack, VStack } from "@chakra-ui/react";
import { useUserChoices } from "@/state/globalStore";
import GenericEmptyComponent from "@/shared/ui/GenericEmptyComponent";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import ProfilePerspectivesMotif from "@/shared/ui/display/ProfilePerspectivesMotif";

export default function StudioEmptyState() {
  const { setInterimState } = useUserChoices();

  return (
    <VStack align="center" gap="3" py={{ base: "4", md: "6" }}>
      <ProfilePerspectivesMotif size="sm" opacity="0.72" />

      <GenericEmptyComponent
        title="Start shaping your profile"
        message="Studio is where you manage the career profile. Add a situation first, or import a CV to create situations and suggested thoughts."
        icon={null}
      />

      <HStack gap="2" justify="center" flexWrap="wrap">
        <Button
          bg="moveon.primary"
          onClick={() => {
            setInterimState("parse_resume", { isOpen: true });
          }}
        >
          <GenericIcon icon="upload" />
          Import CV
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            setInterimState("add_situation", { isOpen: true });
          }}
        >
          <GenericIcon icon="situation" />
          Add situation
        </Button>
      </HStack>
    </VStack>
  );
}
